import { Injectable } from "@angular/core";
import { ApiRoutes } from "../../../config/api-routes";
import { Observable, of } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map } from "rxjs/internal/operators";
import { Contact } from "../model/contact";

@Injectable()
export class ContactService {
  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}

  public getContactsForJob(guid: string): Observable<Contact[]> {
    return this.httpClient
      .get<any>(
        this.apiRoutes.getRouteWithInjectedParams(
          this.apiRoutes.GET_JOB_CONTACTS,
          [guid]
        )
      )
      .pipe(
        map(response => response),
        catchError(error => {
          return of([]);
        })
      );
  }
}
